module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.survey.isPreview) ? _c('el-alert', {
    attrs: {
      "title": "This survey has been published. Questions will not be editable.",
      "type": "warning",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 canvas-wrapper"
  }, [_c('el-card', {
    staticClass: "canvas-card",
    attrs: {
      "shadow": "never",
      "body-style": {
        padding: 0
      }
    }
  }, [_c('question-canvas', {
    attrs: {
      "isEditable": _vm.survey.isPreview
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    ref: "selectorWrapper",
    staticClass: "col-md-4 selector-wrapper"
  }, [_c('el-card', {
    ref: "selectorCard",
    staticClass: "selector-card",
    class: {
      'selector-fixed': _vm.selectorFixed
    },
    style: (_vm.selectorStyle),
    attrs: {
      "shadow": "never",
      "body-style": {
        padding: '0 6px'
      }
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Qualitative",
      "name": "qualitative"
    }
  }, [_c('qualitative-selector-tab', {
    attrs: {
      "selectorFixed": _vm.selectorFixed
    }
  })], 1), _vm._v(" "), (_vm.survey.surveyType === 'MUSIC') ? _c('el-tab-pane', {
    attrs: {
      "label": "Music",
      "name": "music"
    }
  }, [_c('music-selector-tab', {
    attrs: {
      "selectorFixed": _vm.selectorFixed
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('choice-category-create-dialog'), _vm._v(" "), _c('choice-template-save-dialog'), _vm._v(" "), _c('hook-save-dialog'), _vm._v(" "), _c('matrix-choice-save-dialog'), _vm._v(" "), _c('matrix-conditional-logic-dialog'), _vm._v(" "), _c('question-category-create-dialog'), _vm._v(" "), _c('question-conditional-logic-dialog'), _vm._v(" "), _c('question-save-dialog')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4897ec8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/tabs/CanvasTab.vue
// module id = 3424
// module chunks = 3